module.exports = __webpack_public_path__ + "img/Factory.6692cbf4.png";